import { fetchWithToken } from "../platform-core";
import { CORE_BFF_BASE_URL } from "./constants";

interface PermissionsObject {
  [key: string]: boolean;
}

let permissionsRollupPromise: Promise<PermissionsObject>;

export const hasPermission = async (key: string) => {
  // typescript:S6544 - truthy response is acceptable, we're concerned the promise has been created, not resolved.
  // prettier - ignoring the following line to prevent NOSONAR from being moved await from the line its marking.
  // prettier-ignore
  if (!permissionsRollupPromise) { // NOSONAR
    permissionsRollupPromise = fetchWithToken(`${CORE_BFF_BASE_URL}/v1/permissions/rollup`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(JSON.stringify(response));
        }

        return response.json();
      })
      .then((permissionArray: string[]) => {
        const permissions: PermissionsObject = {};

        for (const permissionKey of permissionArray) {
          permissions[permissionKey] = true;
        }

        return permissions;
      });
  }

  return await permissionsRollupPromise
    .then((permissions) => permissions.hasOwnProperty(key))
    .catch((error) => {
      // TODO: not sure if just exploding on failure is the long term play, but that's
      //  how it worked before this promise migration, so that's how it works now.
      console.error(`permission-rollup failed: ${JSON.stringify(error)}`);
      throw new Error("permission-rollup failed");
    });
};

export default hasPermission;
